module.exports = __webpack_public_path__ + "img/icon_autism_surveillance_network_hover.1842285e.svg";